module.exports = __webpack_public_path__ + "static/media/cosplay5.4f703754.jpg";